module.exports = __webpack_public_path__ + "static/media/fb_f.32809285.svg";